import React from 'react'
import { Box, Modal } from '@mui/material'
import { ModalContent } from '../../../common/components'
import { HarnessModal } from './'
import { t } from 'i18next'
import { type SelectionProduct, type ProjectDto, type SystemInfoDto } from '../../../common/services'
import KeyTranslation from '../../../common/KeyTranslation.json'

interface HarnessModalProps {
  open: boolean
  onClose: () => void
  project?: ProjectDto
  systemData?: SystemInfoDto
  systemDatarefetch?: any
  product?: SelectionProduct[] | null

}

export default function ContainerHarnessModal ({ open, onClose, project, systemData, systemDatarefetch, product }: HarnessModalProps): JSX.Element {
  return (
    <Modal open={open} onClose={onClose}>
      <Box>
        <ModalContent onClose={onClose} title={t(KeyTranslation.System_BaseComponents)}>
          {
            <HarnessModal
              open={open}
              onClose={onClose}
              title={t(KeyTranslation.Common_Choose_Harness)}
              project={project}
              systemData={systemData}
              systemDatarefetch={systemDatarefetch}
              product={product}
            />
          }
        </ModalContent>
      </Box>
    </Modal>
  )
}
